// test1508
(1508 && 0);
